// extracted by mini-css-extract-plugin
export default {"Emojify":"bbs_a bht_g"};